// @ts-nocheck
export enum SuperPhaseTypeIds {
  TODO = 1,
  HOLD = 2,
  IN_PROGRESS = 3,
  END = 4,
}
